var render = function () {
  var _vm$$v$form, _vm$$v$form2, _vm$$v$form3, _vm$$v$form4, _vm$$v$form5, _vm$$v$form6, _vm$$v$form7, _vm$$v$form8, _vm$form$currentCondi, _vm$$v$form9, _vm$$v$form10, _vm$$v$form11, _vm$$v$form12, _vm$$v$form13, _vm$$v$form14, _vm$$v$form15, _vm$$v$form16, _vm$$v$form17, _vm$$v$form18, _vm$form$standardValu, _vm$$v$form19, _vm$$v$form20, _vm$$v$form21, _vm$$v$form22, _vm$$v$form23, _vm$$v$form24, _vm$form$conclusion, _vm$form$statusLabel, _vm$form$statusLabel2, _vm$$v$form25, _vm$$v$form26, _vm$$v$form27, _vm$$v$form28;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('c-grid', {
    attrs: {
      "width": "100%",
      "gap": "16px",
      "template-columns": "1fr 1fr 1fr 190px 30px"
    }
  }, [_c('c-box', [_c('FormSelect', {
    attrs: {
      "label": "Indikator ".concat(_vm.index + 1),
      "placeholder": "Pilih indikator ".concat(_vm.index + 1),
      "options": _vm.indicatorOptions,
      "is-required": "",
      "is-helper": "",
      "is-invalid": _vm.isInvalidField((_vm$$v$form = _vm.$v.form) === null || _vm$$v$form === void 0 ? void 0 : _vm$$v$form.indicator),
      "invalid-text": _vm.parseErrors("Indikator ".concat(_vm.index + 1), (_vm$$v$form2 = _vm.$v.form) === null || _vm$$v$form2 === void 0 ? void 0 : _vm$$v$form2.indicator, _vm.customMessageErrors)
    },
    on: {
      "blur": _vm.$v.form.indicator.$touch
    },
    model: {
      value: _vm.form.indicator,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "indicator", $$v);
      },
      expression: "form.indicator"
    }
  }), _vm.form.indicator === 'Lainnya' ? _c('FormInput', {
    attrs: {
      "type": "text",
      "label": "Indicator Lainnya ".concat(_vm.index + 1),
      "placeholder": "Masukkan indikator lainnya",
      "is-required": "",
      "is-helper": "",
      "helper-text-color": "#888",
      "helper-text-type": "info",
      "helper-text": "Maksimal 20 karakter",
      "is-invalid": _vm.isInvalidField((_vm$$v$form3 = _vm.$v.form) === null || _vm$$v$form3 === void 0 ? void 0 : _vm$$v$form3.indicatorOther),
      "invalid-text": _vm.parseErrors("Indikator Lainnya", (_vm$$v$form4 = _vm.$v.form) === null || _vm$$v$form4 === void 0 ? void 0 : _vm$$v$form4.indicatorOther, _vm.customMessageErrors),
      "is-without-label": ""
    },
    on: {
      "blur": _vm.$v.form.indicatorOther.$touch
    },
    model: {
      value: _vm.form.indicatorOther,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "indicatorOther", $$v);
      },
      expression: "form.indicatorOther"
    }
  }) : _vm._e()], 1), _c('c-box', [_c('c-text', {
    attrs: {
      "font-size": ['14px', '16px'],
      "font-weight": "400",
      "font-family": "Roboto",
      "padding": "0px 12px 4px 0px",
      "color": !_vm.form.indicator ? '#888' : _vm.isInvalidField((_vm$$v$form5 = _vm.$v.form) === null || _vm$$v$form5 === void 0 ? void 0 : _vm$$v$form5.currentCondition) || _vm.isInvalidField((_vm$$v$form6 = _vm.$v.form) === null || _vm$$v$form6 === void 0 ? void 0 : _vm$$v$form6.currentConditionUnit) ? '#D32737' : _vm.form.currentCondition && _vm.form.currentConditionUnit ? '#008C81' : '#555'
    }
  }, [_vm._v(" Kondisi Saat ini " + _vm._s(_vm.index + 1) + " "), _c('c-box', {
    attrs: {
      "as": "span",
      "color": "#D32737"
    }
  }, [_vm._v(" * ")])], 1), _c('c-flex', [_c('FormInput', {
    directives: [{
      name: "chakra",
      rawName: "v-chakra",
      value: {
        'input': {
          borderTopRightRadius: '0px !important',
          borderBottomRightRadius: '0px !important'
        }
      },
      expression: "{\n          'input': {\n            borderTopRightRadius: '0px !important',\n            borderBottomRightRadius: '0px !important',\n          }\n        }"
    }],
    attrs: {
      "type": "text",
      "label": "Kondisi Saat ini ".concat(_vm.index + 1),
      "placeholder": "Masukkan kondisi saat ini",
      "is-required": "",
      "is-invalid": _vm.form.indicator ? _vm.isInvalidField((_vm$$v$form7 = _vm.$v.form) === null || _vm$$v$form7 === void 0 ? void 0 : _vm$$v$form7.currentCondition) : false,
      "invalid-text": _vm.parseErrors("Kondisi Saat ini ".concat(_vm.index + 1), (_vm$$v$form8 = _vm.$v.form) === null || _vm$$v$form8 === void 0 ? void 0 : _vm$$v$form8.currentCondition, _vm.customMessageErrors),
      "is-disabled": !_vm.form.indicator,
      "is-without-label": "",
      "flex-grow": "1"
    },
    on: {
      "blur": _vm.$v.form.currentCondition.$touch
    },
    model: {
      value: _vm.form.currentCondition,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "currentCondition", $$v);
      },
      expression: "form.currentCondition"
    }
  }), _c('c-box', {
    attrs: {
      "flex-shrink": "0",
      "width": _vm.form.currentConditionUnit ? "calc(".concat(((_vm$form$currentCondi = _vm.form.currentConditionUnit) === null || _vm$form$currentCondi === void 0 ? void 0 : _vm$form$currentCondi.length) || 3, "ch + ").concat(_vm.isAutomaticConclusion ? '5ch' : '7ch', ")") : '150px',
      "min-width": "64px",
      "max-width": "240px",
      "transition": "all 150ms ease-in-out"
    }
  }, [_vm.isAutomaticConclusion ? _c('FormInput', {
    directives: [{
      name: "chakra",
      rawName: "v-chakra",
      value: {
        'input': {
          borderTopLeftRadius: '0px !important',
          borderBottomLeftRadius: '0px !important',
          backgroundColor: '#F2F2F2 !important',
          color: '#008C81 !important',
          textAlign: 'center'
        }
      },
      expression: "{\n            'input': {\n              borderTopLeftRadius: '0px !important',\n              borderBottomLeftRadius: '0px !important',\n              backgroundColor: '#F2F2F2 !important',\n              color: '#008C81 !important',\n              textAlign: 'center',\n            }\n          }"
    }],
    attrs: {
      "type": "text",
      "label": "",
      "placeholder": "Satuan",
      "is-required": "",
      "is-read-only": "",
      "is-invalid": _vm.form.indicator ? _vm.isInvalidField((_vm$$v$form9 = _vm.$v.form) === null || _vm$$v$form9 === void 0 ? void 0 : _vm$$v$form9.currentConditionUnit) : false,
      "invalid-text": _vm.parseErrors('Lainnya', (_vm$$v$form10 = _vm.$v.form) === null || _vm$$v$form10 === void 0 ? void 0 : _vm$$v$form10.currentConditionUnit, _vm.customMessageErrors),
      "is-without-label": ""
    },
    on: {
      "blur": _vm.$v.form.currentConditionUnit.$touch
    },
    model: {
      value: _vm.form.currentConditionUnit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "currentConditionUnit", $$v);
      },
      expression: "form.currentConditionUnit"
    }
  }) : _c('FormSelect', {
    directives: [{
      name: "chakra",
      rawName: "v-chakra",
      value: {
        'select': {
          borderTopLeftRadius: '0px !important',
          borderBottomLeftRadius: '0px !important',
          backgroundColor: '#F2F2F2'
        }
      },
      expression: "{\n            'select': {\n              borderTopLeftRadius: '0px !important',\n              borderBottomLeftRadius: '0px !important',\n              backgroundColor: '#F2F2F2',\n            }\n          }"
    }],
    attrs: {
      "label": "",
      "placeholder": "Pilih satuan",
      "options": _vm.currentConditionOptions,
      "is-required": "",
      "is-invalid": _vm.form.indicator ? _vm.isInvalidField((_vm$$v$form11 = _vm.$v.form) === null || _vm$$v$form11 === void 0 ? void 0 : _vm$$v$form11.currentConditionUnit) : false,
      "invalid-text": _vm.parseErrors('Satuan', (_vm$$v$form12 = _vm.$v.form) === null || _vm$$v$form12 === void 0 ? void 0 : _vm$$v$form12.currentConditionUnit, _vm.customMessageErrors),
      "is-disabled": !_vm.form.indicator,
      "is-without-label": ""
    },
    on: {
      "blur": _vm.$v.form.currentConditionUnit.$touch
    },
    model: {
      value: _vm.form.currentConditionUnit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "currentConditionUnit", $$v);
      },
      expression: "form.currentConditionUnit"
    }
  })], 1)], 1), _vm.form.currentConditionUnit === 'Lainnya' && _vm.form.indicator ? _c('FormInput', {
    attrs: {
      "type": "text",
      "label": "Kondisi Saat ini ".concat(_vm.index + 1),
      "placeholder": "Masukkan lainnya",
      "is-required": "",
      "is-helper": "",
      "helper-text-color": "#888",
      "helper-text-type": "info",
      "helper-text": "Maksimal 20 karakter",
      "is-invalid": _vm.isInvalidField((_vm$$v$form13 = _vm.$v.form) === null || _vm$$v$form13 === void 0 ? void 0 : _vm$$v$form13.currentConditionUnitOther),
      "invalid-text": _vm.parseErrors('Lainnya', (_vm$$v$form14 = _vm.$v.form) === null || _vm$$v$form14 === void 0 ? void 0 : _vm$$v$form14.currentConditionUnitOther, _vm.customMessageErrors),
      "is-without-label": ""
    },
    on: {
      "blur": _vm.$v.form.currentConditionUnitOther.$touch
    },
    model: {
      value: _vm.form.currentConditionUnitOther,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "currentConditionUnitOther", $$v);
      },
      expression: "form.currentConditionUnitOther"
    }
  }) : _vm._e()], 1), _c('c-box', [_c('c-text', {
    attrs: {
      "font-size": ['14px', '16px'],
      "font-weight": "400",
      "font-family": "Roboto",
      "padding": "0px 12px 4px 0px",
      "color": !_vm.form.indicator ? '#888' : _vm.isInvalidField((_vm$$v$form15 = _vm.$v.form) === null || _vm$$v$form15 === void 0 ? void 0 : _vm$$v$form15.standardValue) || _vm.isInvalidField((_vm$$v$form16 = _vm.$v.form) === null || _vm$$v$form16 === void 0 ? void 0 : _vm$$v$form16.standardValueUnit) ? '#D32737' : _vm.form.standardValue && _vm.form.standardValueUnit ? '#008C81' : '#555'
    }
  }, [_vm._v(" Nilai Standard " + _vm._s(_vm.index + 1) + " "), _c('c-box', {
    attrs: {
      "as": "span",
      "color": "#D32737"
    }
  }, [_vm._v(" * ")])], 1), _c('c-flex', [_c('FormInput', {
    directives: [{
      name: "chakra",
      rawName: "v-chakra",
      value: {
        'input': {
          borderTopRightRadius: '0px !important',
          borderBottomRightRadius: '0px !important'
        }
      },
      expression: "{\n          'input': {\n            borderTopRightRadius: '0px !important',\n            borderBottomRightRadius: '0px !important',\n          }\n        }"
    }],
    attrs: {
      "type": "text",
      "label": "Nilai Standard ".concat(_vm.index + 1),
      "placeholder": "Masukkan nilai standard",
      "is-required": "",
      "is-invalid": _vm.form.indicator ? _vm.isInvalidField((_vm$$v$form17 = _vm.$v.form) === null || _vm$$v$form17 === void 0 ? void 0 : _vm$$v$form17.standardValue) : false,
      "invalid-text": _vm.parseErrors("Nilai Standard ".concat(_vm.index + 1), (_vm$$v$form18 = _vm.$v.form) === null || _vm$$v$form18 === void 0 ? void 0 : _vm$$v$form18.standardValue, _vm.customMessageErrors),
      "is-disabled": !_vm.form.indicator || _vm.isAutomaticConclusion,
      "is-read-only": _vm.isAutomaticConclusion,
      "is-without-label": "",
      "flex-grow": "1"
    },
    on: {
      "blur": _vm.$v.form.standardValue.$touch
    },
    model: {
      value: _vm.form.standardValue,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "standardValue", $$v);
      },
      expression: "form.standardValue"
    }
  }), _c('c-box', {
    attrs: {
      "flex-shrink": "0",
      "width": _vm.form.standardValueUnit ? "calc(".concat(((_vm$form$standardValu = _vm.form.standardValueUnit) === null || _vm$form$standardValu === void 0 ? void 0 : _vm$form$standardValu.length) || 3, "ch + ").concat(_vm.isAutomaticConclusion ? '5ch' : '7ch', ")") : '150px',
      "min-width": "64px",
      "max-width": "240px",
      "transition": "all 150ms ease-in-out"
    }
  }, [_vm.isAutomaticConclusion ? _c('FormInput', {
    directives: [{
      name: "chakra",
      rawName: "v-chakra",
      value: {
        'input': {
          borderTopLeftRadius: '0px !important',
          borderBottomLeftRadius: '0px !important',
          backgroundColor: '#F2F2F2 !important',
          color: '#008C81 !important',
          textAlign: 'center'
        }
      },
      expression: "{\n            'input': {\n              borderTopLeftRadius: '0px !important',\n              borderBottomLeftRadius: '0px !important',\n              backgroundColor: '#F2F2F2 !important',\n              color: '#008C81 !important',\n              textAlign: 'center',\n            }\n          }"
    }],
    attrs: {
      "type": "text",
      "label": "",
      "placeholder": "Satuan",
      "is-required": "",
      "is-read-only": "",
      "is-invalid": _vm.form.indicator ? _vm.isInvalidField((_vm$$v$form19 = _vm.$v.form) === null || _vm$$v$form19 === void 0 ? void 0 : _vm$$v$form19.standardValueUnit) : false,
      "invalid-text": _vm.parseErrors('Lainnya', (_vm$$v$form20 = _vm.$v.form) === null || _vm$$v$form20 === void 0 ? void 0 : _vm$$v$form20.standardValueUnit, _vm.customMessageErrors),
      "is-without-label": ""
    },
    on: {
      "blur": _vm.$v.form.standardValueUnit.$touch
    },
    model: {
      value: _vm.form.standardValueUnit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "standardValueUnit", $$v);
      },
      expression: "form.standardValueUnit"
    }
  }) : _c('FormSelect', {
    directives: [{
      name: "chakra",
      rawName: "v-chakra",
      value: {
        'select': {
          borderTopLeftRadius: '0px !important',
          borderBottomLeftRadius: '0px !important',
          backgroundColor: '#F2F2F2'
        }
      },
      expression: "{\n            'select': {\n              borderTopLeftRadius: '0px !important',\n              borderBottomLeftRadius: '0px !important',\n              backgroundColor: '#F2F2F2',\n            }\n          }"
    }],
    attrs: {
      "label": "",
      "placeholder": "Pilih satuan",
      "options": _vm.standardValueOptions,
      "is-required": "",
      "is-invalid": _vm.form.indicator ? _vm.isInvalidField((_vm$$v$form21 = _vm.$v.form) === null || _vm$$v$form21 === void 0 ? void 0 : _vm$$v$form21.standardValueUnit) : false,
      "invalid-text": _vm.parseErrors('Satuan', (_vm$$v$form22 = _vm.$v.form) === null || _vm$$v$form22 === void 0 ? void 0 : _vm$$v$form22.standardValueUnit, _vm.customMessageErrors),
      "is-disabled": !_vm.form.indicator,
      "is-without-label": ""
    },
    on: {
      "blur": _vm.$v.form.standardValueUnit.$touch
    },
    model: {
      value: _vm.form.standardValueUnit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "standardValueUnit", $$v);
      },
      expression: "form.standardValueUnit"
    }
  })], 1)], 1), _vm.form.standardValueUnit === 'Lainnya' && _vm.form.indicator ? _c('FormInput', {
    attrs: {
      "type": "text",
      "label": "Nilai Standard ini ".concat(_vm.index + 1),
      "placeholder": "Masukkan lainnya",
      "is-required": "",
      "is-helper": "",
      "helper-text-color": "#888",
      "helper-text-type": "info",
      "helper-text": "Maksimal 20 karakter",
      "is-invalid": _vm.isInvalidField((_vm$$v$form23 = _vm.$v.form) === null || _vm$$v$form23 === void 0 ? void 0 : _vm$$v$form23.standardValueUnitOther),
      "invalid-text": _vm.parseErrors("Lainnya", (_vm$$v$form24 = _vm.$v.form) === null || _vm$$v$form24 === void 0 ? void 0 : _vm$$v$form24.standardValueUnitOther, _vm.customMessageErrors),
      "is-without-label": ""
    },
    on: {
      "blur": _vm.$v.form.standardValueUnitOther.$touch
    },
    model: {
      value: _vm.form.standardValueUnitOther,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "standardValueUnitOther", $$v);
      },
      expression: "form.standardValueUnitOther"
    }
  }) : _vm._e()], 1), _c('c-box', [_vm.isAutomaticConclusion ? _c('StatusLabel', {
    attrs: {
      "label": "Kesimpulan ".concat(_vm.index + 1),
      "value": (_vm$form$conclusion = _vm.form.conclusion) !== null && _vm$form$conclusion !== void 0 ? _vm$form$conclusion : '-',
      "color": "green",
      "width": "100%",
      "text-color": (_vm$form$statusLabel = _vm.form.statusLabel) === null || _vm$form$statusLabel === void 0 ? void 0 : _vm$form$statusLabel.color,
      "background-color": (_vm$form$statusLabel2 = _vm.form.statusLabel) === null || _vm$form$statusLabel2 === void 0 ? void 0 : _vm$form$statusLabel2.background
    }
  }) : _c('c-box', [_c('FormSelect', {
    attrs: {
      "label": "Kesimpulan ".concat(_vm.index + 1),
      "placeholder": "Pilih kesimpulan ".concat(_vm.index + 1),
      "options": _vm.conclusionOptions,
      "is-required": "",
      "is-invalid": _vm.form.indicator ? _vm.isInvalidField((_vm$$v$form25 = _vm.$v.form) === null || _vm$$v$form25 === void 0 ? void 0 : _vm$$v$form25.conclusion) : false,
      "invalid-text": _vm.parseErrors("Kesimpulan ".concat(_vm.index + 1), (_vm$$v$form26 = _vm.$v.form) === null || _vm$$v$form26 === void 0 ? void 0 : _vm$$v$form26.conclusion, _vm.customMessageErrors),
      "is-disabled": !_vm.form.indicator
    },
    on: {
      "blur": _vm.$v.form.conclusion.$touch
    },
    model: {
      value: _vm.form.conclusion,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "conclusion", $$v);
      },
      expression: "form.conclusion"
    }
  }), _vm.form.conclusion === 'Lainnya' && _vm.form.indicator ? _c('FormInput', {
    attrs: {
      "type": "text",
      "label": "Kesimpulan Lainnya ".concat(_vm.index + 1),
      "placeholder": "Masukkan kesimpulan lainnya",
      "is-required": "",
      "is-helper": "",
      "helper-text-color": "#888",
      "helper-text-type": "info",
      "helper-text": "Maksimal 20 karakter",
      "is-invalid": _vm.isInvalidField((_vm$$v$form27 = _vm.$v.form) === null || _vm$$v$form27 === void 0 ? void 0 : _vm$$v$form27.conclusionOther),
      "invalid-text": _vm.parseErrors("Kesimpulan Lainnya", (_vm$$v$form28 = _vm.$v.form) === null || _vm$$v$form28 === void 0 ? void 0 : _vm$$v$form28.conclusionOther, _vm.customMessageErrors),
      "is-without-label": ""
    },
    on: {
      "blur": _vm.$v.form.conclusionOther.$touch
    },
    model: {
      value: _vm.form.conclusionOther,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "conclusionOther", $$v);
      },
      expression: "form.conclusionOther"
    }
  }) : _vm._e()], 1)], 1), _vm.index > 1 ? _c('c-box', {
    attrs: {
      "flex-shrink": "0"
    }
  }, [_c('c-button', {
    attrs: {
      "min-width": "30px",
      "width": "30px",
      "height": "30px",
      "margin-top": "42px",
      "padding": "6px",
      "background-color": "transparent"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('remove');
      }
    }
  }, [_c('inline-svg', {
    attrs: {
      "src": require('@/assets/icons/icon-trash.svg'),
      "height": "24px",
      "width": "24px",
      "fill": "#D32737"
    }
  })], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }